import { DynamoDB } from "@aws-sdk/client-dynamodb";
export class FuseInitializerDynamo {
    constructor(inits) {
        Object.defineProperty(this, "_dynamoDb", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_inits", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._inits = inits;
        this._dynamoDb = new DynamoDB(inits);
    }
    getInstance() {
        if (!this._dynamoDb) {
            this._dynamoDb = new DynamoDB(this._inits);
        }
        return this._dynamoDb;
    }
}
